import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";
import moment from "moment";
import { GoogleAuthLoginResponse } from "../../containers/Home/GoogleAndZoom/types";
import $api from "../api/$api";
import {
  TDataToken,
  TGoogleEventQueries
} from "./types";
const linxURl = process.env.NEXT_PUBLIC_LINX_URL;

const googleAuth = async (
  userID: string,
  teamID: string
): Promise<GoogleAuthLoginResponse> => {
  return new Promise((resolve, reject) => {
    const url = `${linxURl}/integrations/google/auth?userID=${userID}&teamID=${teamID}`;
    const authWindow = window.open(url, "_blank", "width=500,height=800");

    if (!authWindow) {
      reject(new Error("Unable to open window"));
      return;
    }

    const messageListener = (event: MessageEvent) => {
      if (event.data.type === "google-auth") {
        resolve({
          isSuccessGoogleLogin: event.data.isSuccessGoogleLogin,
          type: event.data.type,
          errorMessage: event.data.errorMessage
        });
        window.removeEventListener("message", messageListener);
      }
    };

    window.addEventListener("message", messageListener, false);
  });
};

export const useGoogleLogin = (
  config?: UseMutationOptions<any, unknown, unknown>
) => {
  return useMutation({
    mutationFn: ({ userID, teamID }: { userID: string; teamID: string }) =>
      googleAuth(userID, teamID),
    ...config
  });
};

// get events
export const getGoogleEvents = (
  data: TDataToken,
  queries: TGoogleEventQueries
) => {
  const {teamId, userId} = queries;

  const currentDate = moment();
  const sixHoursAgo = currentDate.clone().subtract(6, 'hours');
  const oneMonthLater = currentDate.clone().add(1, "month");
  
  return $api
    .get(`users/${userId}/teams/${teamId}/google-calendar-events`, {
      // @ts-ignore
      token: data.accessToken,
      params: {
        timeMin: sixHoursAgo.toISOString(),
        timeMax: oneMonthLater.toISOString()
      }
    })
    .then((response) => {
      return response;
    });
};

export const useGetGoogleEvents = (
  data: TDataToken,
  queries?: TGoogleEventQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["google-events", queries],
    queryFn: () => getGoogleEvents(data, queries),
    ...(config as UseQueryOptions<any>)
  });
};
